// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"0bbbaa7d","453":"af63d155"}[chunkId] + ".chunk.js";
};